import { connect } from "react-redux";
import * as actions from "./actions";
import { invocate, deleteInvocations, changePath } from "../Wizard/actions";
import BusinessStep from "../../components/BusinessStep";
import { WizardProps } from "../Wizard";
import { BusinessStepReducer } from "./reducer";

type ReducerProps = {
  businessStep: BusinessStepReducer;
  wizard: WizardProps;
};

const mapStateToProps = ({ businessStep, wizard }: ReducerProps) => ({
  loading: businessStep.loading,
  businesses: businessStep.businesses,
  subCategories: businessStep.subCategories,
  invocations: wizard.invocations,
  publisher: wizard.publisher,
});

export default connect(mapStateToProps, { invocate, deleteInvocations, changePath, ...actions })(BusinessStep);
